import shopInfos from './infos'

type RecordValue = Record<string, unknown>
const isRecord = (value: unknown): value is RecordValue =>
  typeof value === 'object' && value !== null && !Array.isArray(value)

// This copied family-shop starter points at categories absent from the demo.
// Match its complete editorial identity, not an empty product result: the API
// deliberately returns zero products for every builderOnly settings request.
const starterTargets = new Set([
  '/m/schlafsaecke/33001383',
  '/m/kinderbettwaesche/1008',
  '/m/wickelauflagen/33001405',
  '/m/Krabbeldecke/33001413',
  '/m/stillkissen/33001404',
  '/m/kinder-und-baby-kissen/33001397',
  '/m/windeltasche/33001406',
  '/m/kinderwagen-organizer/33001407',
  '/m/fuer-das-baby-pflege-und-reinigung/1330',
])

const isCopiedStarter = (value: unknown): boolean => {
  if (!isRecord(value) || value.enabled !== true || !isRecord(value.hero)
    || value.hero.title !== 'Für kleine Wunder und entspannte Familienmomente'
    || value.hero.eyebrow !== 'Sanft. Praktisch. Modern.') return false

  const targets = new Set<string>()
  const visit = (item: unknown) => {
    if (Array.isArray(item)) item.forEach(visit)
    else if (isRecord(item)) {
      if (typeof item.href === 'string' && item.href.startsWith('/m/')) targets.add(item.href)
      Object.values(item).forEach(visit)
    }
  }
  visit(value)
  return targets.size === starterTargets.size && [...targets].every(target => starterTargets.has(target))
}

export const customizeProductPages = (response: unknown, request: unknown): unknown => {
  if (!isRecord(request) || Number(request.shop) !== 205 || request.homePage !== true
    || request.includeMetadata === false || !isRecord(response) || !isRecord(response.filterProducts)
    || !isRecord(response.menu)
    || response.menu.titel !== 'Familien-Shop - liebevolle Begleiter für Baby und Familie'
    || !isCopiedStarter(response.sitePageBuilder)) return response

  const page = response.menu.pageBuilder
  if (isRecord(page) && page.enabled === true && !isCopiedStarter(page)) return response

  // An explicit disabled setting also replaces a previously cached starter on
  // the client. The existing demo TextHome provides the actual homepage copy.
  const fallback = { enabled: false }
  return {
    ...response,
    sitePageBuilder: fallback,
    menu: {
      ...response.menu,
      titel: shopInfos.title,
      description: shopInfos.description,
      metaTitle: shopInfos.title,
      metaDescription: shopInfos.description,
      metaKeywords: '',
      pageBuilder: fallback,
    },
  }
}
